import React from 'react';
import AboutPage from '../base/components/AboutPage';
/* eslint-enable no-unused-vars */
import MainDivBase from '../base/components/MainDivBase';
import { setNavContext, setNavProps } from '../base/components/NavBar';
import KStatus from '../base/data/KStatus';
// import TestPage from '../base/components/TestPage';
import Share from '../base/data/Share';
import { getDataItem, setWindowTitle } from '../base/plumbing/Crud';
// Plumbing
import DataStore from '../base/plumbing/DataStore';
import { notifyUser } from '../base/plumbing/Messaging';
import Roles, { isTester } from '../base/Roles';
import detectAdBlock from '../base/utils/DetectAdBlock';
import { encURI } from '../base/utils/miscutils';
import Login from '../base/youagain';
import C from '../C';
import ServerIO from '../plumbing/ServerIO';
import { GoodLoopAccountPage } from './AccountPage';
import AdOverviewPage from './AdOverviewPage';
import AdvertiserDashPage from './AdvertiserDashPage';
import AdvertiserPage from './AdvertiserPage';
import AdvertPage from './AdvertPage';
import DisplayAdvertPage from './DisplayAdvertPage';
import AgencyPage from './AgencyPage';
import BotManagementPage from './BotManagementPage';
import BugReportPage from './BugReportPage';
import CampaignPage from './CampaignPage';
import CharitySignUpPage from './CharitySignUpPage';
import DashboardPage from './DashboardPage';
// Init special PropControl widgets
// import PropControls from '../base/components/PropControls'; -- done in app
// Pages
import JoinUsPage from './JoinUsPage';
import JournalPage from './JournalPage';
import LineItemPage from './LineItemPage';
/* eslint-disable no-unused-vars */
import MiscOverrides from './MiscOverrides'; // Overrides part of the Misc object just by importing
import NGOPage from './NGOPage';
import PubDashPage from './PubDashPage';
import PublisherPage from './PublisherPage';
import PubListPage from './PubListPage';
import GreenTagPage from './greentag/GreenTagPage';
import SMAPage from './SnogMarryAvoidPage';
import SystemPage from './SystemPage';
import ScheduledContentPage from './ScheduledContentPage';
import TagTestPage from './TagTestPage';
// import ChatTestPage from './ChatTestPage';
import BlogEditorPage from './BlogEditorPage';
import GreenTagReportPage from './GreenTagReportPage';
import FontsPage from './FontsPage';
import T4GPage from './T4GPage';
import DonationPage from './DonationPage';
import UserPage from './UserPage';
import CarbonPage from './CarbonPage';
import ImpactCreditPage from './ImpactCreditPage';
import ImpactDebitPage from './ImpactDebitPage';
import ImpactAllocationPage from './ImpactAllocationPage';
import MeasurePage from './MeasurePage';
import CertificatePage from './CertificatePage';
import EditPopUpPage from '../base/components/EditPopUpPage';
import PortalFooter from './PortalFooter';
import DSPMeasurePage from './DSPMeasurePage';

ServerIO.USE_PROFILER = true;

// Protect unused imports from removal
let dummy = MiscOverrides;

const PAGES = {
	advertiser: AdvertiserPage,
	bots: BotManagementPage,
	advert: AdvertPage,
	displayad: DisplayAdvertPage,
	certificate: CertificatePage,
	vert: AdvertPage, // NB for robustness, be a bit lax on (ad)vert
	lineitem: LineItemPage,
	vertiser: AdvertiserPage,
	agency: AgencyPage,
	ngo: NGOPage,
	campaign: CampaignPage,
	dashboard: DashboardPage,
	pubdash: PubDashPage,
	publist: PubListPage,
	vertdash: AdvertiserDashPage,
	account: GoodLoopAccountPage,
	publisher: PublisherPage,
	sma: SMAPage,
	system: SystemPage,
	journal: JournalPage,
	tagtest: TagTestPage,
	// adsignup: AdSignUpPage,
	charitysignup: CharitySignUpPage,
	join: JoinUsPage,
	adoverview: AdOverviewPage,
	about: AboutPage,
	// video: VideoMakerPage,
	// chattest: ChatTestPage,
	green: GreenTagPage,
	greenreport: GreenTagReportPage,
	impactallocation: ImpactAllocationPage,
	impactcredit: ImpactCreditPage,
	impactdebit: ImpactDebitPage,	
	// blog: BlogEditorPage,
	fonts: FontsPage,
	donation: DonationPage,
	carbon: CarbonPage,
	bugreport: BugReportPage,
	// scheduledcontent: ScheduledContentPage, // "my.ads"
	t4g: T4GPage,
	user: UserPage,
	measure: MeasurePage,
	editpopup: EditPopUpPage,
	dspmeasure: DSPMeasurePage,
};

/**
 * HACK: True if for non-Good-Loop users (or not logged in)
 */
const restrictNav = () => {
	// const myRoles = Roles.getRoles().value;
	return ! isTester(); // (!myRoles || !myRoles.length || (myRoles.length === 1 && myRoles[0] === 'greenUser'));
};

const noLoginPages = { tagtest: true, pubsignup: true, adsignup: true, green: true };

const securityCheck = ({page}) => {
	// must login and be an admin for most pages
	if (!Login.isLoggedIn()) {
		if (!noLoginPages[page]) {
			throw new Error('Not Logged In');
		}
	}
	
	// Check for adblockers -- bit of a hack, but a good place to put this so it gets called during render
	let pvab = detectAdBlock();
	if (pvab.value) {
		notifyUser("You appear to have adblock enabled. This may cause GoodLoop to function incorrectly.");
	}

	return true;
};

/**
 * Decides where a user should be routed if they do not specify a page
 * Not logged in: ??
 * Admin: dashboard
 * No pub shares: ??
 * Non-admin with a pub: pubdash
 * On error: join
 * @returns {String[]} location path, [page, id], or null if waiting on info
 */
const getDefaultPage = () => {
	if ( ! Login.isLoggedIn()) {
		return ['green']; // TODO go back to the `join` page. But for now the only external users are Green Ad Tag
	}
	if (isTester()) {
		return ['advertiser'];
	}
	if (true) {
		return ['green']; // for now the only external users are Green Ad Tag
	}

	if( false && Roles.iCan(C.CAN.admin).value ) {
		return ['dashboard'];
	}
	// shared Publisher page?
	const pvSharedWithMe = DataStore.fetch(['misc','sharedWithMe'], () => {
		return Login.getSharedWith(Login.getId());
	});
	// wait for share and access information to resolve
	if ( ! pvSharedWithMe.resolved) {
		return null;
	}
	// // check if user already has a registered website/pubdash page
	// if( ! yessy(pvSharedWithMe.value)) {
	// 	return ['pubsignup'];
	// }
	// Their pub
	let shares = pvSharedWithMe.value;
	if ( ! shares) {
		// some error from You-Again?
		console.error("YouAgain share list failed", pvSharedWithMe);
		return ['join'];
	}
	let pubs = Share.stripPrefix(shares, C.TYPES.Publisher+":");
	if ( ! pubs[0]) {
		return ['join'];
	}
	// return ['pubdash', pubs[0]];
};


/**
 * Let MainDivBase dynamically request the page list on render
 * - otherwise this component has to be connected to the store too.
 * @returns {!String[]}
 */
const getNavbarPages = () => {
	setWindowTitle("Good-Loop Portal");	// reset default title

	// Advertiser?
	let vertiser = DataStore.getUrlValue('vertiser');
	if (vertiser) {
		setNavContext(C.TYPES.Advertiser, vertiser, true);
	}

	// Remove pages from navbar that the user shouldn't see
	// HACK No navigation for non-GL users
	if (restrictNav()) {
		return [];
	}
	let pages = ['dashboard', 'advertiser', 'agency', 'ngo', 'campaign', 
		'advert', 'displayad',
		'green', 'user', 
		// 'blog', 
		'fonts', 'donation', 'carbon', 'impactdebit', 'impactcredit', 't4g', 
		'bugreport'];
	// mothballed but might still be used: 'lineitem', 'publisher', 'system', 'journal'
	
	if ( ! Roles.iCan('editAdvert')) {
		pages = pages.filter(page => !{advertiser: true, advert: true, campaign: true, lineitem: true}[page]);
	}

	if ( ! Roles.iCan('editSite')) {
		pages = pages.filter(page => page !== 'publisher');
	}

	if ( ! Roles.iCan('admin')) {
		pages = pages.filter(page => ! {user:true, system: true, journal: true}[page]);
	}

	return pages;
};

// const getNavbarLabels = () => {
// let pvAdvertiser = vertiser && getDataItem({type:C.TYPES.Advertiser, id:vertiser, status:C.KStatus.Published});
// let advLogo = pvAdvertiser && pvAdvertiser.value && pvAdvertiser.value.branding && pvAdvertiser.value.branding.logo;


function MainDiv() {
	// HACK Don't hide navbar, but don't present an easy link away for users who should have restricted navigation
	let homeLink;
	
	if (restrictNav()) {
		homeLink = () => {
			const path = DataStore.getValue('location', 'path') || [];
			return `/#${path.join('/')}`;
		};
	}

	// let [npages, nlabels] = getNavbarPages();
	return (<MainDivBase
		pageForPath={PAGES}
		defaultPage={getDefaultPage}
		homeLink={homeLink}
		securityCheck={securityCheck}
		SecurityFailPage={JoinUsPage}
		navbarPages={getNavbarPages}
		navbarLabels={{bugreport: 'report a bug'}}
		fullWidthPages={['advert', 'vert', 'editpopup', 'displayad']}
		undecoratedPages={['editpopup']}
		Footer={PortalFooter}
		noRegister
	/>);
}


export default MainDiv;
